import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOAD_MORE_LOCATION_DEALS_EVENT } from '../../constants/analyticEvents';
import { DEALS_PER_PAGE } from '../../constants/constants';
import { pushEvent } from '../../utilities/analytics';
import { selectTotalDealsCount } from '../dealsList/dealsListSlice';
import { selectSecondaryFilter } from '../secondaryFilter/secondaryFilterSlice';
import LocationDealsList from './LocationDealsList';
import {
  fetchHotelPrices,
  getSession,
  loadMoreHotelPrices,
  loadMoreLocationDeals,
  selectLocationDealsList,
  setShowSoldOutAlert,
  setIsPricesFetched,
  fetchLocationDealsData,
  clearHotelPrices,
} from './locationDealsSlice';
import SoldOutAlert from './SoldOutAlert';
import {
  selectActiveDestinations,
  selectFilterData,
  selectFiltersLoaded,
  specificDateSelected
} from '../mainFilter/selectors';

function LocationDeals({
  noResults,
}) {
  const dispatch = useDispatch();
  const {
    list,
    hideSoldOutDeals,
    hotelPrices,
    session,
    pagination,
    error,
    pending,
    sessionPending,
    showSoldOutAlert,
  } = useSelector(selectLocationDealsList);
  const [selectedDestination] = useSelector(selectActiveDestinations);
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const search = useSelector(state => state.userSearch);
  const mainFilter = useSelector(selectFilterData);
  const isSpecific = useSelector(specificDateSelected);
  const priceGraphTop = useSelector((state) => state.app.priceGraphTop);
  const cachedDealsCount = useSelector(selectTotalDealsCount);
  const filtersReady = useSelector(selectFiltersLoaded);

  let dealsList = list;

  if (priceGraphTop && cachedDealsCount <= DEALS_PER_PAGE) {
    dealsList = [...list].slice(0, list.length - (cachedDealsCount % 4));
  }

  const [page, setPage] = useState(0);
  const initialLoad = useRef(true);

  const { fromwhere, who } = mainFilter.searchEngine;
  // const selectedDeparture = fromwhere.find(item => item.active) || fromwhere[0];
  const selectedDepartures = fromwhere.filter(item => item.active);
  const selectedDeparturesString = selectedDepartures.map(dp => dp.id).join(',') || fromwhere[0].id;

  useEffect(() => {
    initialLoad.current = false;
  }, [dispatch]);

  useEffect(() => {
    if (!initialLoad) {
      if (isSpecific && filtersReady && selectedDestination) {
        dispatch(fetchHotelPrices());
      } else {
        dispatch(fetchLocationDealsData({ selectedDestination }));
      }
    }
  }, [dispatch, secondaryFilter.data, selectedDeparturesString, isSpecific, filtersReady, selectedDestination]);

  useEffect(() => {
    if (isSpecific && list.length > 0 && !sessionPending) {
      dispatch(getSession());
    }
  }, [dispatch, isSpecific, list, who, search.staticDeal?.id]);

  useEffect(() => {
    dispatch(setIsPricesFetched(false));
  }, [selectedDeparturesString]);

  useEffect(() => {
    if (isSpecific && session.session_id) {
      setPage(0);
      dispatch(fetchHotelPrices());
    }
  }, [dispatch, session.session_id, secondaryFilter.data]);

  useEffect(() => {
    if (
      isSpecific &&
      hotelPrices.offers.length > 0 &&
      list
        .slice(0, 20)
        .filter((item) =>
          hotelPrices.offers.some(
            (offer) => offer.hotel.provider_hotel_id === item.id
          )
        ).length < 10
    ) {
      dispatch(setShowSoldOutAlert(true));
    } else {
      dispatch(setShowSoldOutAlert(false));

    }
  }, [hotelPrices.offers, isSpecific, list]);

  useEffect(() => {
    dispatch(setShowSoldOutAlert(false));
    dispatch(clearHotelPrices())
  }, [dispatch, selectedDestination])

  const onLoadMoreClick = () => {
    if (isSpecific) {
      dispatch(loadMoreHotelPrices(page + 1));
      setPage(page + 1);
    } else {
      dispatch(
        loadMoreLocationDeals({
          destination: selectedDestination.id,
          filters: { ...secondaryFilter.data },
        })
      );
    }

    pushEvent(LOAD_MORE_LOCATION_DEALS_EVENT, { countPage: page + 2 });
  };

  const renderContent = (
    <>
      {isSpecific && showSoldOutAlert && !priceGraphTop && (
        <SoldOutAlert />
      )}
      <LocationDealsList
        list={dealsList}
        prices={hotelPrices}
        error={error}
        onLoadMore={onLoadMoreClick}
        pagination={pagination}
        isSpecific={isSpecific}
        hideSoldOutDeals={hideSoldOutDeals}
        priceGraphTop={priceGraphTop}
        pending={pending}
      />
    </>
  );

  //if (priceGraphTop && noResults) {
  if (noResults) {
    return '';
  }

  if (priceGraphTop) {
    return renderContent;
  }

  return (
    <div className="deal-list c-row">{renderContent}</div>
  );
}

export default LocationDeals;
